'use client';

import { Sparkles, TrendingUp, Cpu, BarChart3 } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-900 via-emerald-900 to-teal-900 overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-emerald-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse" />
        <div className="absolute top-40 right-10 w-72 h-72 bg-teal-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse animation-delay-2000" />
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-cyan-500 rounded-full mix-blend-multiply filter blur-3xl animate-pulse animation-delay-4000" />
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Badge */}
        <div className="flex justify-center mb-8">
          <div className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
            <Sparkles className="w-5 h-5 text-yellow-400" />
            <span className="text-white font-semibold">Exclusive Opportunity Showcase</span>
          </div>
        </div>

        {/* Main Heading */}
        <div className="text-center max-w-5xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            The
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 via-teal-400 to-cyan-400 animate-gradient">
              Billion Dollar Secret Sauce
            </span>
            Transforming ESG into Profitability
          </h1>
          
          <p className="text-xl md:text-2xl text-white/90 mb-8 leading-relaxed">
            Discover GenCarbon's proprietary methodologies and advanced technological capabilities 
            for transforming sustainability challenges into profitable opportunities
          </p>

          {/* Technology Badges */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {[
              { icon: Cpu, label: 'AI-Powered Analytics', color: 'from-blue-500 to-cyan-600' },
              { icon: BarChart3, label: 'Quantum Computing', color: 'from-purple-500 to-pink-600' },
              { icon: TrendingUp, label: 'Predictive Intelligence', color: 'from-emerald-500 to-teal-600' }
            ]?.map((tech, index) => {
              const IconComponent = tech?.icon;
              return (
                <div
                  key={index}
                  className={`inline-flex items-center gap-3 px-6 py-3 bg-gradient-to-r ${tech?.color} rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300`}
                >
                  <IconComponent className="w-5 h-5 text-white" />
                  <span className="text-white font-semibold">{tech?.label}</span>
                </div>
              );
            })}
          </div>

          {/* Value Proposition */}
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 max-w-3xl mx-auto">
            <p className="text-lg text-white/90 leading-relaxed">
              <span className="font-bold text-emerald-400">We have the math, statistics, and algorithms</span> — 
              from AI to Quantum Computing — to accurately measure, review, and validate your sustainability 
              journey while accelerating your path to profitability.
            </p>
          </div>
        </div>
      </div>
      {/* Decorative Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
          <path d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="white" fillOpacity="0.1"/>
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;